import React, { Fragment } from 'react';
import { Col, Form, FormGroup, Label, Input } from 'reactstrap';
import { Image } from '../../../AbstractElements';
import { useSelector, useDispatch } from 'react-redux';
import { setField } from '../../../Features/Learning/Materi/addMaterialSlice';
import RichEditor from '../../../Component/Editor/RichEditor/RichEditor';

const MateriForm = () => {
  const dispatch = useDispatch()
  const data = useSelector(state => state.addMaterial)

  const handleChanges = (e) => {
    const { name, value } = e.target;
    dispatch(setField({ field: name, value: value }));
  }
  const handleChangeDescription = (e) => {
    dispatch(setField({ field: 'description', value: e }));
  }
  return (
    <Fragment>
      <Form className="row needs-validation">
        <Col sm="12">
          <FormGroup className='mb-3'>
            <Label for="validationName" style={{ fontWeight: 'bold' }}>{'Nama Materi'}:</Label>
            <Input className="form-control" id="validationName" type="text" name="name" placeholder="Masukkan Nama Materi..." required=""
              value={data.name}
              onChange={handleChanges} />
            <div className="valid-feedback">{'Looks good!'}</div>
          </FormGroup>
          <FormGroup className='mb-3'>
            <Label for="validationDescription" style={{ fontWeight: 'bold' }}>{'Description'}:</Label>
            <RichEditor id="validationDescription" handleChangeDescription={handleChangeDescription} description={data.description} />
          </FormGroup>
          {data.imageLink && (
            <FormGroup className='mb-3'>
              <Image attrImage={{ className: 'img-fluid', width: '500px', src: data.imageLink, alt: data.name }} />
            </FormGroup>
          )}
        </Col>
      </Form>
    </Fragment>
  );
};
export default MateriForm;